var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.menuName,{tag:"component",attrs:{"dataInstagramDefault":_vm.dataInstagramDefault},on:{"addSticker":_vm.addSticker,"updateSticker":_vm.updateSticker,"changeMenu":_vm.changeMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }